const specialCharacters = {
  FIELD_SEPARATOR: String.fromCharCode(28), // 
  GROUP_SEPARATOR: String.fromCharCode(29), // 
  HEARTBEAT: String.fromCharCode(17), // 
};

export { specialCharacters };
